import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import station from "../station";
import core from "../../core/core.module";

angular
    .module('stationsControl.stationsEdit', [station, core, angularUIB])
    .component('stationsEdit', {
        controller: ['Station', 'notifier', 'Data', controller],
        template: require('./stations-edit.component.html'),
        bindings: {
            station: '<',
            additionalNames: '<',
            isActive: '<',
            priority: '<',
            isParentStation: '<',
            parentStation: '<',
            childStationsTransferMinutes: '<'
        }
    });

function controller(Station, notifier, Data) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        if (!$ctrl.additionalNames.length) {
            $ctrl.additionalNames.push(null);
        }
    };

    $ctrl.searchStations = function (fragment) {
        return Data.getStations(fragment);
    };

    $ctrl.addName = function () {
        $ctrl.additionalNames.push(null);
    };

    $ctrl.delName = function (ind) {
        $ctrl.additionalNames.splice(ind, 1);
    };

    $ctrl.save = function () {
        $ctrl.loading = false;
        Station
            .update($ctrl.station.Id, {
                additionalNames: $ctrl.additionalNames,
                isActive: $ctrl.isActive,
                priority: $ctrl.priority,
                isParentStation: $ctrl.isParentStation,
                parentStationCode: $ctrl.parentStation ? $ctrl.parentStation.code : null,
                childStationsTransferMinutes: $ctrl.childStationsTransferMinutes,
            })
            .then(
                function () {
                    notifier.successNotify('Данные успешно сохранились');
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default 'stationsControl.stationsEdit';


// WEBPACK FOOTER //
// ./resources/assets/modules/stations-control/stations-edit/stations-edit.component.js